import BlogRenderer from '../ParentRenderer.jsx';
import {
    loadPortfolio,
    savePortfolio,
    updatePortfolio,
} from '../../utilities/Portfolios/publishedPortfolioUtils.js';
import {
    loadUserProjects,
    updateProject,
} from '../../../ProjectsAndSkills/Projects/utilities/projectsUtils.js';
import {
    loadUserSkills,
    updateSkill,
} from '../../../ProjectsAndSkills/Skills/utilities/skillsUtils.js';
import { loadUserJobs } from '../../../Jobs/utilities/jobsUtils.js';
import { getUserImages } from '../../../Common/Images/utilities/imageUtils.js';
import { generateImageDescriptions } from '../../../AI/utilities/aiLogicService.js';
import { loadPortfolioGenerationContext } from '../../../AI/NewBlogSystem/utilities/portfolioAiContext.js';


const PublishedPortfolioRenderer = ({ edit = false }) => {
    const getGenerationContext = (options = {}) => loadPortfolioGenerationContext({
        ...options,
        loadProjects: loadUserProjects,
        loadSkills: loadUserSkills,
        loadJobs: loadUserJobs,
        loadImages: getUserImages,
        describeImages: generateImageDescriptions,
    });

    return (
        <BlogRenderer
            edit={edit}
            loadPortfolio={loadPortfolio}
            savePortfolio={savePortfolio}
            updatePortfolio={updatePortfolio}
            ai={true}
            aiMethods={{ getGenerationContext, updateProject, updateSkill }}
        />
    )
};

export default PublishedPortfolioRenderer;
